export default "__VITE_ASSET__3f0f3dd6__"